var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePromo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 138,
    viewBox: "0 0 175 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1039 132C22.9267 108.159 26.6581 93.0415 39.9499 73.3379",
    stroke: "#2653F5",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4753 56.6935C70.8994 37.6592 84.6519 28.5495 108.86 22.2471",
    stroke: "black",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.014 11.5284C127.695 12.2659 125.618 15.405 126.375 18.5399C127.132 21.6748 130.437 23.6183 133.756 22.8808L131.014 11.5284ZM133.756 22.8808C141.028 21.265 146.745 20.6385 152.166 20.9539C157.565 21.2679 162.999 22.5351 169.66 25.0779L174.34 14.2587C166.803 11.382 160.054 9.72346 153.006 9.31353C145.981 8.90497 138.989 9.75638 131.014 11.5284L133.756 22.8808Z",
    fill: "#1E40BA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePromo2);
export default __webpack_public_path__ + "static/media/home-promo-2.63b28d949f96c31e9cb606a4d683cda1.svg";
export { ForwardRef as ReactComponent };